// components/Services.js
import React from 'react';
import serviceImage from '../assets/images/3.jpeg';

function Services() {
  const services = [
    {
      title: "Cross-Border Fuel Transportation",
      description: "Secure haulage of petrol, diesel, jet fuel, and lubricants tailored to regional needs.",
      image: serviceImage
    },
    {
      title: "•	Customs and Regulatory Compliance",
      description: "Expertise in managing cross-border documentation and trade regulations.",
      image: serviceImage
    },
    {
      title: "Fleet Solutions",
      description: "Modern, ADR-certified tankers equipped with advanced safety and monitoring systems.",
      image: serviceImage
    },
    {
      title: "Risk Management",
      description: "24/7 emergency response and real-time cargo tracking.",
      image: serviceImage
    }
  ];

  return (
    <section className="service_section layout_padding">
      <div className="service_container">
        <div className="container">
          <div className="heading_container">
            <h2>Our <span>Transport Solutions</span></h2>
            <p>Our leadership brings decades of experience in logistics, petroleum distribution, and regional trade. Their knowledge and commitment ensure innovative, community-focused solutions.</p>
          </div>
          <div className="row">
            {services.map((service, index) => (
              <div className="col-md-6" key={index}>
                <div className="box">
                  <div className="img-box">
                    <img src={service.image} alt={service.title} />
                  </div>
                  <div className="detail-box">
                    <h5>{service.title}</h5>
                    <p>{service.description}</p>
                    <a href="#">Learn More</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;